import styled from "styled-components";

export const LogoContainer = styled.div`
  position: fixed;
  width: 160px;
  top: 0;
  left: 40px;

  @media (min-width: 1900px) {
    width: 200px;
  }
`;

export const LayoutCard = styled.div`
  width: 450px;
  border-radius: 10px;
  padding: 20px 30px;
  background-color: #ffffff;
  margin-top: 50px;
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.15);
  @media (min-width: 1900px) {
    width: 500px;
    padding: 30px 40px;
  }
`;
